<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :loading="loading"
      :error="errors[0]"
      :normal-label="normalLabel"
      classes="pull_left"
    >
      <div :class="radioGroupClass">
        <ul>
          <li
            v-for="(option, optionIndex) in options"
            :key="`${formControlId}_${optionIndex}`"
          >
            <input
              type="radio"
              :id="`${formControlId}_${optionIndex}`"
              :value="option"
              v-model="proxy"
              @change="onInput"
              class="form_input_radio"
              v-bind="formControlOptions"
            />
            <label :title="option" :for="`${formControlId}_${optionIndex}`">
              <span class="label_inner_text">{{ option }}</span>
            </label>
          </li>
        </ul>
      </div>
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsRadio',
  mixins: [formControlMixin],
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      proxy: [],
    };
  },
  computed: {
    radioGroupClass() {
      return {
        'radio_group_4 mobile_width_half': !this.big,
        'radio_group_3 mobile_full_width': this.big,
      };
    },
  },
};
</script>
